(function ($) {
  DJ.addBehavior('accordion', '.js-accordion', {
    attach: function () {
      const accordion = this;
      const accordionTrigger = Array.prototype.slice.call(accordion.querySelectorAll('.js-accordion-item__trigger'));
      const accordionContent = Array.prototype.slice.call(accordion.querySelectorAll('.js-accordion-item__content'));

      /**
       * Return false if no trigger and content.
       */
      if (!accordionTrigger.length || !accordionContent.length) {
        return false;
      }

      if (accordionTrigger.length === 1) {
        const triggerElement = accordionTrigger[0];

        triggerElement.removeAttribute('aria-expanded');
        triggerElement.removeAttribute('aria-controls');
        triggerElement.removeAttribute('tabindex');
        triggerElement.classList.add('accordion-item__trigger--single');

        return false;
      }

      /**
       * Set attribute for the elements.
       *
       * @param {Array} elements
       *  Elements for which need to set attribute.
       * @param {string} attrName
       *  Attribute name.
       *  @param {string} value
       *  Attribute value.
       */
      const setAttrForEach = (elements, attrName, value) => {
        elements.forEach((e) => {
          e.setAttribute(attrName, value);
        });
      };

      /**
       * When init opens last accordion item and close other.
       *
       * @param itemTrigger
       *  Accordion trigger html element.
       * @param itemContent.
       *  Accordion content html element.
       */
      const openItemOnInit = (itemTrigger, itemContent) => {
        setTimeout(() => {
          setAttrForEach(accordionTrigger, 'aria-expanded', 'false');
          setAttrForEach(accordionContent, 'hidden', '');

          itemTrigger.setAttribute('aria-expanded', 'true');
          itemContent.removeAttribute('hidden');
        }, 1);
      };

      const triggerLast = accordionTrigger.length - 1;
      const contentLast = accordionContent.length - 1;

      openItemOnInit(accordionTrigger[triggerLast], accordionContent[contentLast]);

      /**
       * Add event click on each accordion trigger.
       * On click open/close accordion element.
       */
      accordionTrigger.forEach((e) => {
        e.addEventListener('click', function () {
          const target = this;
          const isExpanded = target.getAttribute('aria-expanded') === 'true';

          function toggleAccordion(ariaExpandedValue, ariaControlsSetRemove) {
            target.setAttribute('aria-expanded', ariaExpandedValue);

            if (ariaControlsSetRemove) {
              document.getElementById(target.getAttribute('aria-controls')).setAttribute('hidden', '');
            } else {
              document.getElementById(target.getAttribute('aria-controls')).removeAttribute('hidden');
            }
          }

          if (isExpanded) {
            toggleAccordion('false', true);
          } else {
            toggleAccordion('true', false);
          }
        });

        /**
         * Add event keydown on each accordion trigger.
         * On keydown open/close accordion element.
         */
        e.addEventListener('keydown', function (el) {
          const code = el.keyCode || el.which;

          if (code === 13) {
            $(this).click();
          }
        });
      });

      return true;
    }
  });
})(jQuery);
